'use client'

import { useEffect, useState } from 'react'
import ScrollResourcePopup from './ScrollResourcePopup'
import ScrollOfferPopup from './ScrollOfferPopup'
import { type PopupVariant } from '@/lib/popupSession'

interface ResourceConfig {
  title: string
  description: string
  bulletPoints: string[]
  ctaText: string
}

interface CoursePopupChooserProps {
  postId: string
  resource: ResourceConfig
}

// Shared session cap key so the offer + magnet both count toward "max 2 per session".
const CAP_KEY = 'aibc_course_popup_count'

export default function CoursePopupChooser({ postId, resource }: CoursePopupChooserProps) {
  const [variant, setVariant] = useState<PopupVariant | null>(null)

  useEffect(() => {
    // Dev/QA override: /blog/...?popup=offer or ?popup=magnet forces the variant.
    const override = new URLSearchParams(window.location.search).get('popup')
    if (override === 'offer' || override === 'magnet') {
      setVariant(override)
      return
    }
    // Always-on offer on course articles (A/B coin flip retired — exposure was
    // the bottleneck, not the offer). Pass ?popup=magnet to preview the magnet.
    setVariant('offer')
  }, [])

  if (variant === null) return null

  return variant === 'offer' ? (
    <ScrollOfferPopup postId={postId} resource={resource} capKey={CAP_KEY} />
  ) : (
    <ScrollResourcePopup postId={postId} resource={resource} capKey={CAP_KEY} />
  )
}
